<template>
  <article class="order">
    <header class="order-header">
      <div>{{ $t('order.heading', { number: order.order_number }) }}</div>
      <div class="capitalize">{{ $t('order.date', { date: orderDate }) }}</div>
    </header>
    <div class="px-4 py-8" v-if="order.fulfillments">
      <div v-for="ff in order.fulfillments.data" :key="ff.id" class="mb-6">
        <OrderFulfillment :ff="ff" />
      </div>
    </div>
  </article>
</template>

<script>
import OrderFulfillment from './OrderFulfillment';
import { format } from 'date-fns';

export default {
  components: { OrderFulfillment },
  props: {
    order: Object,
  },
  computed: {
    orderDate() {
      const d = this.order && this.order.date;
      return d ? format(new Date(this.order.date), 'M/d/yy') : null;
    },
  },
};
</script>
